import React from 'react'
import PropTypes from 'prop-types'
import {
  Form,
  FormInput,
  FormButton,
  Margin,
  Text,
  Row,
  Col,
} from 'shared/components'

import * as styles from './styles'

const BeneficiaryFormComponent = ({ form, onSubmitForm }) => (
  <Form form={form} onSubmit={onSubmitForm}>
    <Margin tb={1}>
      <FormInput
        name="beneficiaryName"
        label="Beneficiary Name"
        placeholder="Beneficiary company/organization name"
      />
    </Margin>

    <Margin tb={2}>
      <Row>
        <Col xs={6}>
          <FormInput
            name="contactFirstName"
            label="First Name"
            placeholder="First Name"
          />
        </Col>
        <Col xs={6}>
          <FormInput
            name="contactLastName"
            label="Last Name"
            placeholder="Last Name"
          />
        </Col>
      </Row>
    </Margin>

    <Margin bottom={1}>
      <FormInput
        name="email"
        label="Contact person's email address"
        type="email"
        placeholder="account@email.com"
      />
    </Margin>

    <Margin tb={1}>
      <FormInput
        name="website"
        label="Charity / Beneficiary website"
        placeholder="URL to the website"
      />
    </Margin>

    <Margin tb={1}>
      <FormInput
        name="bankAccount"
        label="Bank Account Number"
        placeholder="Enter Bank Account Number"
      />
    </Margin>

    <Margin tb={1}>
      <FormInput name="taxId" label="TaxId" placeholder="NNN-NN-NNNN" />
    </Margin>

    <Margin tb={1}>
      <Row>
        <Col xs={6}>
          <FormInput
            label="Country"
            name="country"
            placeholder="Name of the country"
          />
        </Col>
        <Col xs={6}>
          <FormInput
            name="zip"
            label="Postal Code/ZIP Code"
            placeholder="Postal or ZIP code"
          />
        </Col>
      </Row>
    </Margin>
    <Margin tb={1}>
      <Row>
        <Col xs={6}>
          <FormInput
            label="State/Province/Region"
            name="state"
            placeholder="Name of the state etc."
          />
        </Col>
        <Col xs={6}>
          <FormInput
            label="City/Town"
            name="city"
            placeholder="Name of the city or town"
          />
        </Col>
      </Row>
    </Margin>
    <Margin tb={1}>
      <FormInput
        label="Address Line 1"
        name="address1"
        placeholder="Street number and name (e.g., 123 Main St)"
      />
    </Margin>
    <Margin tb={1}>
      <FormInput
        label="Address Line 2"
        name="address2"
        placeholder="Apartment, suite, unit, building, floor"
      />
    </Margin>

    <Margin top={2} bottom={3}>
      <Text size={16} upper bold>
        Set up your login credentials:
      </Text>
    </Margin>

    <Margin tb={2}>
      <FormInput
        name="password"
        label="Password"
        type="password"
        placeholder="Enter your password"
      />
    </Margin>
    <Margin tb={2}>
      <FormInput
        name="confirmation"
        label="Confirm Password"
        type="password"
        placeholder="Enter your password"
      />
    </Margin>

    <Margin top={2} css={styles.buttonContainer}>
      <FormButton submit size="large" css={styles.signupButton}>
        <Text size={16} upper bold black>
          Confirm Registration
        </Text>
      </FormButton>
    </Margin>
  </Form>
)

BeneficiaryFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmitForm: PropTypes.func.isRequired,
}

export default BeneficiaryFormComponent
